import classNames from 'classnames';
import { postSeperator, postSeperatorDot } from '../Post.css';

interface Props {
  className?: string;
}

const DotSeperator = ({ className }: Props) => {
  return (
    <div className={classNames(className)}>
      <div className={classNames(postSeperatorDot, 'w-1 h-1 rounded-full')} />
    </div>
  );
};

const DashSeperator = ({ className }: Props) => {
  return (
    <div className={classNames(postSeperator, className)}>
      <span>-</span>
    </div>
  );
};

const LineSeperator = ({ className }: Props) => {
  return (
    <div className={classNames(postSeperator, className)}>
      <span>|</span>
    </div>
  );
};

const SlashSeperator = ({ className }: Props) => {
  return (
    <div className={classNames(postSeperator, className)}>
      <span>/</span>
    </div>
  );
};

interface SeperatorProps {
  type: 'dot-separator' | 'dash-separator' | 'line-separator' | 'slash-separator';
  className?: string;
}

const Seperator = ({ type, className }: SeperatorProps) => {
  switch (type) {
    case 'dot-separator':
      return <DotSeperator className={className} />;
    case 'dash-separator':
      return <DashSeperator className={className} />;
    case 'line-separator':
      return <LineSeperator className={className} />;
    case 'slash-separator':
      return <SlashSeperator className={className} />;
  }
};

export default Seperator;
